export default __webpack_public_path__ + "static/media/truck.7c0debe5.svg";